<script>
import { videoMethods, orgComputed, orgMethods } from '@/src/state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...orgComputed,
    colors() {
      return {
        '--color': this.primaryColor,
      };
    },
  },
  mounted() {},
  methods: {
    ...videoMethods,
    ...orgMethods,
    hide() {
      this.$bvModal.hide('end-workout-modal');
      this.setVideoAction('play');
    },
    stopWorkout() {
      // TODO: Stop workout and update workout with the most recent progess
      this.hide();
      this.$router.replace({ name: 'home' });
    },
  },
};
</script>

<template>
  <b-modal id="end-workout-modal" centered :hide-footer="true" :hide-header="true" no-stacking>
    <div class="end-workout-container">
      <h1 class="title" :style="colors">Stop Workout</h1>
      <p>Are you sure you want to stop your workout right now?</p>
    </div>
    <p class="close-text" @click="hide">
      No, Close & Continue
    </p>
    <BaseButton class="button btn-primary large" @click="stopWorkout">
      Stop Workout
    </BaseButton>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

::v-deep .modal-dialog {
  max-width: 700px !important;
  min-width: 20%;

  .modal-content {
    background: white;
    border-radius: $base-border-radius-md;
    box-shadow: 0 0 3px rgba(171, 171, 171, 0.5);

    .modal-body {
      min-height: 45vh;

      @include media('xxl', null) {
        margin-top: 3.9rem;
      }

      .end-workout-container {
        display: flex;
        flex-direction: column;

        .title {
          color: var(--color);
          font-size: 26.78px;
          font-style: normal;
          font-weight: bold;
          line-height: 3.7rem;
          text-align: center;
          text-transform: capitalize;
        }
      }

      .close-text {
        bottom: 4.5rem;
        font-size: 1.7rem;
        font-weight: 600;
        line-height: 2.8rem;
        opacity: 0.5;
        position: absolute;
        text-align: center;
        text-transform: capitalize;

        &:hover {
          cursor: pointer;
        }
      }

      .btn-primary {
        bottom: -3rem;
        position: absolute;
        width: 60%;
      }
    }
  }
}
</style>
